let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("11AqV")).then(() => parcelRequire('7GWq2'));